import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=1b2753bd&scoped=true&"
import script from "./NavigationPanel.vue?vue&type=script&lang=js&"
export * from "./NavigationPanel.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPanel.vue?vue&type=style&index=0&id=1b2753bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2753bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2753bd')) {
      api.createRecord('1b2753bd', component.options)
    } else {
      api.reload('1b2753bd', component.options)
    }
    module.hot.accept("./NavigationPanel.vue?vue&type=template&id=1b2753bd&scoped=true&", function () {
      api.rerender('1b2753bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/NavigationPanel.vue"
export default component.exports